import { DiscoverFilterDialog } from './DiscoverFilterDialog';

export default DiscoverFilterDialog;
